/**
 * Store pour les tâches du client connecté dont dont on charge les propositions accpetés
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';

export const useAuthCompletedTaskStore = defineStore('authCompletedTask', (() => {

    // State des tâches chargées
    const completedTasks = ref([]);

    /**
     * Retourne la tâche dont l'identifiant public est en paramètre
     * @param int publicId
     * @return object|null
     */
    const getCompletedTaskByPublicId = computed(() => {
        return ((publicId) => {
            const index = completedTasks.value.findIndex((taskFromState) => taskFromState.publicId === publicId);
            if(index === -1) {
                return null;
            }
            return completedTasks.value[index];
        });
    });

    /**
     * Chargement des données d'une tâche par identifiant public
     * @param int publicId
     * @param bool force Vrai si on force le rechargement des données
     * @return Promise
     */
    const loadCompletedTaskByPublicId = ((publicId, force = false) => {

        const loadedTask = getCompletedTaskByPublicId.value(publicId);
        if(loadedTask !== null && ! force) {
            return Promise.resolve();
        }

        const path = '/api/me/tasks/:publicId/completed'.replace(':publicId', publicId);

        return axios.get(path).then((response) => {
            if(response && response.data && response.data.success && response.data.task) {
                updateCompletedTask(response.data.task);
                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Modifie une tâche dans le store
     * @param object task Données de la tâche à mettre à jour dans le store
     * @return Promise
     */
    const updateCompletedTask = ((task) => {

        const currentTasks = completedTasks.value;

        const index = currentTasks.findIndex((taskFromState) => taskFromState.publicId === task.publicId);
        if(index !== -1) {
            completedTasks.value[index] = { ...completedTasks.value[index], ...task };
        } else {
            completedTasks.value.push(task);
        }

    });

    /**
     * Enlève une tâche du tableau
     * @param object task
     * @return void
     */
    const forgetTask = ((task) => {
        const indexToRemove = completedTasks.value.findIndex((taskFromState) => taskFromState.publicId === task.publicId);
        if(indexToRemove !== -1) {
            completedTasks.value.splice(indexToRemove, 1);
        }
    });

    return {
        getCompletedTaskByPublicId,
        loadCompletedTaskByPublicId,
        forgetTask
    };

}));


